import '../../app.scss';
import React, { useEffect } from "react";
import Banner from './main-banner/Banner.js';
import Footer from './footer/Footer.js';
import SEO from '../SEO.js';
import { Helmet } from 'react-helmet';





function Landing() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const softwareSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "Pred",
    operatingSystem: "Web-based",
    applicationCategory: "BusinessApplication",
    description: "Pred is a specialized AI application by Rain, designed for high-precision demand forecasting and operational predictive analytics.",
    url: "https://www.rain.one/apps/pred",
    publisher: {
      "@type": "Organization",
      name: "Rain",
      url: "https://www.rain.one"
    },
    screenshot: "https://www.rain.one/assets/Screenshotrain.png",
    featureList: [
      "AI Demand Forecasting",
      "Operational Efficiency",
      "Data-driven Insights",
      "Predictive Modeling"
    ]
  };



  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(softwareSchema)}
        </script>
      </Helmet>
      <SEO
        url='https://www.rain.one/pred'
      />
      <Banner />
      <Footer />
    </>
  );
}

export default Landing;
